export const showAllQuery = "!showall";
